import type { SchoolDetail } from './types';
import { group1 } from './group1';
import { group2 } from './group2';
import { group3 } from './group3';
import { group4 } from './group4';

export type { DetailSection, SchoolDetail } from './types';

export const overseasSchoolDetails: Record<string, SchoolDetail> = {
  ...group1,
  ...group2,
  ...group3,
  ...group4,
};

export function detailFor(slug: string): SchoolDetail | undefined {
  return overseasSchoolDetails[slug];
}
